/**
 * Brand Configuration.
 * Dynamically resolves brand identity reading adminStore.brandOverride first, then env defaults.
 */

function getActiveBrand() {
  let override = null;
  if (typeof localStorage !== 'undefined') {
    try {
      const raw = localStorage.getItem('te_admin_v1');
      if (raw) {
        const parsed = JSON.parse(raw);
        override = parsed?.brandOverride;
      }
    } catch (e) {
      // Ignore parse errors
    }
  }

  const productName = override?.productName || import.meta.env.VITE_PRODUCT_NAME || 'Titanium Ed-Tech';
  const schoolName = override?.schoolName || import.meta.env.VITE_SCHOOL_NAME || 'Radhika International School';
  const tagline = override?.tagline !== undefined ? override.tagline : '';
  const shortName = override?.shortName || productName.split(' ')[0] || 'Titanium';
  const logoText = override?.logoText || 'TE';

  return {
    productName,
    schoolName,
    tagline,
    shortName,
    logoText
  };
}

export const BRAND = new Proxy({}, {
  get(target, prop) {
    const active = getActiveBrand();
    return active[prop];
  }
});
